"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _blExchangeAppointment = require("@/api/blExchangeAppointment/blExchangeAppointment");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _indexSetterDate = _interopRequireDefault(require("./indexSetterDate"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: "searchContainerPh",
  components: {
    dragDialog: _DragDialog.default,
    Pagination: _Pagination.default,
    indexSetterDate: _indexSetterDate.default
  },
  props: {
    blNo: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      listQuery: {
        currentPage: 1,
        pageSize: 100,
        namedParameters: {}
      },
      total: 0,
      tableData: [],
      poolTypeList: [],
      form: {
        setterDate: ''
      },
      loading: null,
      hotSettings: {
        dragCheck: true,
        height: 'calc(50vh - 215px)',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        fragmentSelection: 'cell',
        copyPaste: false
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    handleSearch: function handleSearch() {
      var _this = this;
      this.loading = (0, _utils.load)();
      (0, _blExchangeAppointment.searchContainer)(this.listQuery).then(function (res) {
        if (res.success) {
          _this.total = res.data.totalRecord;
          _this.listQuery.currentPage = res.data.currentPage;
          _this.listQuery.pageSize = res.data.pageSize;
          _this.tableData = res.data.records;
        }
      }).catch(function (err) {}).finally(function () {
        _this.loading.close();
      });
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    //下一步
    handleNext: function handleNext() {
      var _this2 = this;
      this.loading = (0, _utils.load)();
      (0, _blExchangeAppointment.doForespeakPH)(this.tableData).then(function (res) {
        console.log(res);
      }).catch(function (error) {}).finally(function () {
        _this2.loading.close();
      });
      this.$emit('handleNextConfirmPrint');
    },
    opened: function opened() {
      this.listQuery.namedParameters.blNo = this.blNo;
      this.handleSearch();
    },
    handleDatePickerBlur: function handleDatePickerBlur() {
      var _this3 = this;
      this.tableData.forEach(function (item) {
        _this3.$set(item, 'setterDate', _this3.form.setterDate);
      });
      this.$refs.hotTable.resizeTo();
    },
    closed: function closed() {},
    handleInitEdit: function handleInitEdit() {},
    handleConfirmPrint: function handleConfirmPrint() {
      this.$emit('handleConfirmPrint');
    }
  }
};